import { Component, computed, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, inject, Output } from '@angular/core';
import { SlickOnboardAgency } from '../../service/slick-onboard-agency/slick-onboard-agency';
import { FormField } from '@angular/forms/signals';

@Component({
  selector: 'oba-agency-details',
  imports: [FormField],
  templateUrl: './agency-details.html',
  styleUrl: './agency-details.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AgencyDetails {

  @Output() stepComplete = new EventEmitter<boolean>();

  currencyOptions: { label: string, value: string, flag: string }[] = [
    { label: 'USD', value: 'usd', flag: '🇺🇸' },
    { label: 'GBP', value: 'gbp', flag: '🇬🇧' },
    { label: 'EUR', value: 'eur', flag: '🇪🇺' },
  ];

  selectedCurrencyLabel = computed(() => {
    const code = this.slickAgencyService.agencyFormModel().currencyCode;
    const opt = this.currencyOptions.find((c) => c.value === code);
    return opt ? `${opt.flag} ${opt.label}` : 'Select currency';
  });

  /** Services */
  public slickAgencyService = inject(SlickOnboardAgency);
  /** Services - END */

  onCurrencySelected(code: string): void {
    this.slickAgencyService.agencyFormModel.update((m) => ({ ...m, currencyCode: code }));
    this.slickAgencyService.agencyForm.currencyCode().markAsTouched();
  }

  saveAgencyDetails() {
    console.log('saveAgencyDetails()');
    this.stepComplete.emit(true);
  }

  canSubmit() {
    return this.slickAgencyService.agencyForm.agencyName().valid() &&
      this.slickAgencyService.agencyForm.agencyWebsite().valid() &&
      this.slickAgencyService.agencyForm.currencyCode().valid();
  }
}
